import { render } from "./KafedraTaqsimoti.vue?vue&type=template&id=493a0290&scoped=true"
import script from "./KafedraTaqsimoti.vue?vue&type=script&lang=js"
export * from "./KafedraTaqsimoti.vue?vue&type=script&lang=js"

import "./KafedraTaqsimoti.vue?vue&type=style&index=0&id=493a0290&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-493a0290"]])

export default __exports__